(() => {
  if (window.eatNudeCardsInitialized) return;

  window.eatNudeCardsInitialized = true;

  const getCartItemSectionIds = () => {
    const ids = [];

    document.querySelectorAll('cart-items-component[data-section-id]').forEach((item) => {
      if (item.dataset.sectionId) ids.push(item.dataset.sectionId);
    });

    return [...new Set(ids)];
  };

  const dispatchHorizonCartUpdate = ({ cart, sections, variantId, sourceId }) => {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId,
          data: {
            source: 'eatnude-product-card',
            itemCount: cart.item_count,
            variantId: String(variantId),
            sections,
          },
        },
      })
    );
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-en-card-add]');

    if (!(button instanceof HTMLButtonElement)) return;

    if (button.disabled) return;

    const cartUrl = button.dataset.cartUrl || '/cart';
    if (button.dataset.enCartRecovery === 'true') {
      window.location.assign(cartUrl);
      return;
    }

    const variantId = button.dataset.variantId;
    const defaultLabel = button.dataset.enDefaultLabel || button.textContent.trim();
    button.dataset.enDefaultLabel = defaultLabel;
    const status = button.parentElement.querySelector('[data-en-card-status]');
    const announce = (message) => {
      if (status) status.textContent = message;
    };

    if (!variantId) return;

    button.textContent = 'Adding...';
    button.disabled = true;
    announce('Adding to cart.');
    let added = false;
    let rejected = false;

    try {
      const sectionIds = getCartItemSectionIds();
      const body = {
        id: Number(variantId),
        quantity: 1,
      };

      if (sectionIds.length) {
        body.sections = sectionIds.join(',');
      }

      const addResponse = await fetch(`${cartUrl}/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });

      // Only a definite rejection is safe to offer as another add attempt.
      rejected = addResponse.status >= 400 && addResponse.status < 500;
      if (!addResponse.ok) throw new Error('Unable to add item');
      added = true;

      const addedItem = await addResponse.json();
      if (addedItem.status) {
        added = false;
        rejected = addedItem.status >= 400 && addedItem.status < 500;
        throw new Error(addedItem.message || 'Unable to add item');
      }

      const response = await fetch(`${cartUrl}.js`);
      if (!response.ok) throw new Error('Unable to refresh cart');
      const cart = await response.json();
      if (!Number.isInteger(cart.item_count) || !Array.isArray(cart.items)) {
        throw new Error('Invalid cart response');
      }

      dispatchHorizonCartUpdate({
        cart,
        sections: addedItem.sections,
        variantId,
        sourceId: button.closest('[data-product-id]')?.dataset.productId || String(variantId),
      });

      button.textContent = 'Added';
      announce('Added to cart.');
      button.classList.add('en-card__add-btn--added');

      window.setTimeout(() => {
        button.textContent = defaultLabel;
        button.classList.remove('en-card__add-btn--added');
        button.disabled = false;
      }, 1800);
    } catch {
      if (rejected) {
        button.textContent = defaultLabel;
        announce('The item could not be added. Please try again or check the product availability.');
      } else {
        // A failed refresh or an uncertain POST must never become a second POST.
        button.dataset.enCartRecovery = 'true';
        button.textContent = added ? 'View cart' : 'Check cart';
        button.setAttribute('aria-label', added ? 'Item added. View cart' : 'Check cart before adding again');
        announce(added
          ? 'Added to cart, but the cart could not refresh. Select View cart to see your items.'
          : 'We could not confirm whether the item was added. Select Check cart before trying again.');
      }
      button.disabled = false;
    }
  });
})();
